/**
 * Retrieve form data
 * @param {HTMLFormElement} form
 * @param {object} additionalData
 * @returns {object}
 */
function getFormData(form, additionalData = {}) {
	const formData = new FormData(form);
	const object = {};

	for (const [key, value] of Object.entries(additionalData)) {
		formData.append(key, value);
	}

	formData.forEach((value, key) => {
		// Reflect.has in favor of: object.hasOwnProperty(key)
		if (!Reflect.has(object, key)) {
			object[key] = value;
			return;
		}
		if (!Array.isArray(object[key])) {
			object[key] = [object[key]];
		}

		console.error(`This form doesn't support multiple values, so probably your key '${key}' is duplicated.`);
		object[key].push(value);
	});

	return object;
}
